import type { UseMutationOptions } from '@tanstack/react-query';
import type { ApiErrorNotificationMeta } from '@/context/apiErrorNotificationProvider';

type Params<TData, TError, TVariables, TContext> = UseMutationOptions<TData, TError, TVariables, TContext>;

export interface MutationOptionsWithNotification<TData, TError = unknown, TVariables = void, TContext = unknown>
  extends Params<TData, TError, TVariables, TContext> {
  disableErrorNotification?: boolean;
  meta?: ApiErrorNotificationMeta;
}

export const mergeApiErrorNotificationMeta = (
  defaultMeta: ApiErrorNotificationMeta | undefined,
  userMeta: ApiErrorNotificationMeta | undefined,
  disableErrorNotification?: boolean
): ApiErrorNotificationMeta | undefined => {
  const baseMeta: ApiErrorNotificationMeta = {
    ...(defaultMeta ?? {}),
    ...(userMeta ?? {}),
  };

  if (disableErrorNotification) {
    return {
      ...baseMeta,
      skip: true,
    };
  }

  return Object.keys(baseMeta).length > 0 ? baseMeta : undefined;
};
